export default __webpack_public_path__ + "static/media/staff_out_arrow.af9a3fa5.svg";